import React from 'react';
import { withRouter } from 'react-router-dom';
import {
  ContainerPrincipal,
} from './RendimentoMensalNegociadoresStyles';

function RendimentoMensalNegociadoresComponent() {
  return (
    <ContainerPrincipal>
      <p>Aguarde!  Opção em desenvolvimento</p>
    </ContainerPrincipal>
  );
}

export const RendimentoMensalNegociadores = withRouter(RendimentoMensalNegociadoresComponent);
